const genderList = [
    { value: 1, text_en: 'Male', text_bn: 'পুরুষ' },
    { value: 2, text_en: 'Female', text_bn: 'মহিলা' }
]

const publicServiceStatus = [
    {
        value: 1,
        text_en: 'Pending',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 2,
        text_en: 'Processing',
        text_bn: 'প্রক্রিয়াধীন'
    },
    {
        value: 3,
        text_en: 'Reviewed',
        text_bn: 'পর্যালোচনা'
    },
    {
        value: 4,
        text_en: 'Approved',
        text_bn: 'অনুমোদিত'
    },
    {
        value: 5,
        text_en: 'Disbursed',
        text_bn: 'বিতরণ'
    },
    {
        value: 6,
        text_en: 'Rejected',
        text_bn: 'প্রত্যাখ্যাত'
    }
]

const statusList = [
    {
        value: 1,
        text_en: 'Paid',
        text_bn: 'পরিশোধিত'
    },
    {
        value: 2,
        text_en: 'Not Paid',
        text_bn: 'পরিশোধ করা হয়নি'
    }
]

export default {
  genderList,
  publicServiceStatus,
  statusList
}
